/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { CustomTalentAlertType } from '../enums/custom-talent-alert-type';
export class UserCustomTalentAlertEntity extends Entity {
  alertActive: boolean = false;
  alertType: CustomTalentAlertType | null = null;
  candidateId: string | null = null;
  id: string = '';
  minAvailability: number | null = null;
  candidateName?: string | null = null;
  static override key = 'UserCustomTalentAlert';
  static override schema = {};
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'UserCustomTalentAlert' in input
    ) {
      const { UserCustomTalentAlert: wrapped, ...rest } = input as {
        UserCustomTalentAlert: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}